import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { ArbetsorderBeteckningResolver } from "~app/features/planera/arbetsorder-beteckning.resolver";
import { MinaMaskinlagComponent } from "~app/features/planera/mina-maskinlag/mina-maskinlag.component";
import { PlaneraComponent } from "~app/features/planera/planera.component";
import { ProduktionsmallarComponent } from "~app/features/planera/produktionsmallar/produktionsmallar.component";
import { ProduktinstruktionerDetailsComponent } from "~app/features/produktion/produktinstruktioner/produktinstruktioner-details/produktinstruktioner-details.component";
import { ProduktinstruktionerMassEditComponent } from "~app/features/produktion/produktinstruktioner/produktinstruktioner-massedit/produktinstruktioner-massedit.component";
import { ProduktinstruktionerComponent } from "~app/features/produktion/produktinstruktioner/produktinstruktioner.component";
import { ProduktionsmalComponent } from "~app/features/produktion/produktionsmal/produktionsmal.component";
import { SandningloggComponent } from "~app/features/produktion/sandninglogg/sandninglogg.component";

export const produktionRoutes: Routes = [
    {
        path: "planera",
        redirectTo: "planera/",
        pathMatch: "full"
    },
    {
        path: "planera/:id",
        title: "Planera",
        component: PlaneraComponent,
        canDeactivate: [DirtyGuard],
        resolve: {
            arbetsorderId: ArbetsorderBeteckningResolver
        },
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktionsleda]
        }
    },
    {
        path: "minamaskinlag",
        component: MinaMaskinlagComponent,
        canDeactivate: [DirtyGuard],
        title: "Mina maskinlag",
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Titta]
        }
    },
    {
        path: "minaproduktionsmallar",
        title: "Mina produktionsmallar",
        component: ProduktionsmallarComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Produktionsleda],
            editRoles: [RaskRoller.role.Produktionsleda],
            isCKMall: false
        }
    },
    {
        path: "produktionsmal",
        title: "Produktionsmål",
        component: ProduktionsmalComponent,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Kundhantera]
        }
    },
    {
        path: "sandningslogg",
        title: "Sändningslogg",
        component: SandningloggComponent,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktinstruktionsadmininstrera]
        }
    },
    {
        path: "produktinstruktioner",
        title: "Produktinstruktioner",
        children: [
            {
                path: "",
                component: ProduktinstruktionerComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktinstruktionsadmininstrera]
                }
            },
            {
                path: ":puid",
                title: "Produktinstruktion detaljer",
                canDeactivate: [DirtyGuard],
                component: ProduktinstruktionerDetailsComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktinstruktionsadmininstrera],
                    skipEnvironmentTitleStrategyForRoute: true
                }
            },
            {
                path: "massedit/:puids",
                title: "Massändra produktinstruktioner",
                component: ProduktinstruktionerMassEditComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktinstruktionsadmininstrera]
                }
            }
        ]
    }
];
